import React, {useEffect, useRef, useState} from 'react';
import {useSearchParams} from "react-router";
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";
import ReportUtils from "../../../utils/report-utils.js";
import axios from "axios";
import Content from "./components/content.jsx";
import InputSwitch from "../../../components/input/input-switch.jsx";
const API_URL = import.meta.env.VITE_API_URL;
const ZoomedPassage = () => {
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [reportData, setReportData] = useState(null);
    const [dataLength, setDataLength] = useState(0)
    const [title] = useState("Registro de passagem");
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [showMoreInformation, setShowMoreInformation] = useState(false);

    const apply = async (filters) => {
        ReportUtils.applyLoad({
            setLoading,
            clearContent: () => {
                setReportData(null)
            }
        });

        try {
            const { data: response } = await axios.post(API_URL + "/reports/export_zoomed_passage_images/apply", filters);

            const data = response.data;
            setReportData(data);
            setDataLength(data?.image_url.length || data?.passage_description.length || data?.pcl_description.length || 0)

        } catch (error) {
            ReportUtils.alertErrorMessage("Erro ao gerar o relatório.");
            console.error("Erro ao gerar o relatório", error);

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let image_url = searchParams.get("image_url")

        if (image_url){
            const x =searchParams.get("x")
            const y =searchParams.get("y")
            const width =searchParams.get("width")
            const height =searchParams.get("height")

            image_url += `?x=${x}&y=${y}&width=${width}&height=${height}`
        }

        const filters = {
            "proc_id": searchParams.get("proc_id"),
            "capture_time": searchParams.get("capture_time"),
            "image_url": image_url,
        }

        apply(filters)
    }, []);

    const printComponentRef = useRef(null);

    return (
        <div className={"flex"}>
            <Template isLoading={loading}>
                <Template.Header>
                    <div className="flex justify-between w-full">
                        <Template.Title>{title}</Template.Title>
                        <div className={"flex gap-6"}>
                            <InputSwitch
                                id="show-more-information"
                                label="Exibir metadados"
                                checked={showMoreInformation}
                                onChange={setShowMoreInformation}
                            />
                            <div className="ml-auto">
                                <HeaderButtons
                                    exportable={false}
                                    exportInSheets={false}
                                    printable={true}
                                    headerChange={true}
                                    printComponentRef={printComponentRef}
                                    reportData={reportData}
                                    data={dataLength}
                                    headerSelected={headerSelected}
                                    setHeaderSelected={setHeaderSelected}
                                />
                            </div>
                        </div>
                    </div>
                </Template.Header>
            </Template>
            <Card className={`w-full h-fit m-2 ${!reportData || dataLength === 0 ? 'mt-[59px]' : 'mt-[61px]' } print:!mt-[-15px] transform ${!reportData || dataLength === 0 ? '!bg-[#f3f3f4] !border-none !-translate-y-[5px]' : ''}`}>
                <Card.Body>
                    <div className={`flex-1 ${!reportData || dataLength === 0 ? 'p-[0]' : 'py-[5px]'}`}>
                        <Content reportData={reportData} data={dataLength} entity={headerSelected} title={title} setLoading={setLoading} printComponentRef={printComponentRef} showMoreInformation={showMoreInformation}/>
                    </div>
                </Card.Body>
            </Card>

        </div>
    );
};

export default ZoomedPassage;
